import { render, staticRenderFns } from "./permission.vue?vue&type=template&id=c6f9fb3e&scoped=true&"
import script from "./permission.vue?vue&type=script&lang=js&"
export * from "./permission.vue?vue&type=script&lang=js&"
import style0 from "./permission.vue?vue&type=style&index=0&id=c6f9fb3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f9fb3e",
  null
  
)

export default component.exports